export default __webpack_public_path__ + "static/blogImg-bad94b7adc415f40846972a6de2091db.png";